import script from "./HomeIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeIcon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__